import { Send } from "@mui/icons-material";
import { InputAdornment, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import BNBox from "../BNBox/BNBox";
import BNIconButton from "../BNIconButton/BNIconButton";
import BNInput from "../FormElements/BNInput/BNInput";
import { useChatContext } from "../NobaChat/NobaChat";

export const ChatPlaceholder = ({ title, placeholder }: { title: string; placeholder: string }) => {
  const [question, setQuestion] = useState<string>("");
  const inputRef = React.useRef<HTMLInputElement>(null);
  const theme = useTheme();
  const chatContext = useChatContext();
  const ask = () => {
    if (!question) return;
    setQuestion("");
    inputRef.current?.blur();
    chatContext?.sendMessage(question);
  };
  return (
    <>
      <Typography variant="h4" component={"h2"}>
        {title}
      </Typography>
      <BNBox sx={{ display: "flex", alignItems: "center" }}>
        <BNInput
          value={question}
          onChange={(event) => setQuestion(event.target.value)}
          placeholder={placeholder}
          onKeyUp={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              ask();
            }
          }}
          inputRef={inputRef}
          sx={{
            ".MuiInputBase-root:hover .MuiInputAdornment-root.MuiInputAdornment-root": {
              border: `1px solid ${theme.vars.palette.secondary.dark}`,
              borderLeft: "none",
            },
            ".MuiInputBase-root:hover .MuiInputBase-input": {
              borderColor: "secondary.dark",
            },
            ".MuiInputBase-root.Mui-focused .MuiInputAdornment-root.MuiInputAdornment-root": {
              border: `2px solid ${theme.vars.palette.secondary.dark}`,
              borderLeft: "none",
              px: "1.1rem",
              py: "2.3rem",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                sx={[
                  {
                    borderLeft: 0,
                    backgroundColor: "shadow.white",
                  },
                  theme.applyStyles("dark", {
                    backgroundColor: "tertiary.dark",
                  }),
                ]}
              >
                <BNIconButton
                  sx={[
                    {
                      marginLeft: 1,
                      backgroundColor: "primary.lighter",
                      ["&:hover"]: {
                        backgroundColor: "primary.main",
                      },
                    },
                    theme.applyStyles("dark", { backgroundColor: "primary.darker" }),
                  ]}
                  onClick={() => ask()}
                >
                  <Send sx={[theme.applyStyles("dark", { color: "background.default" })]} />
                </BNIconButton>
              </InputAdornment>
            ),
          }}
        />
      </BNBox>
    </>
  );
};
